import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import ContactUsModal from './contactUsModal';
import Image from 'next/image';

export default function InfoSection({ title, description, documentationLink, customServiceName, lang, contactButton }) {
  const { t } = useTranslation('common');

  const href = description === 'terraform.description' ? documentationLink : documentationLink + lang + `/${customServiceName || `Welcome`}.html`

  return (
    <section className={`first_section ${contactButton ? 'section_shadow' : ''}`}>
      <div className="first_section__img">
        <Image src='/main.webp' alt="" layout='fill' objectFit='cover' unoptimized priority />
      </div>
      <div className="first_section__content">
        <h1 dangerouslySetInnerHTML={{ __html: title }} />
        { description && <p>{t(description)}</p> }
        <div className="buttons">
          <Link href='/configuration'>
            <a className='btn cloud'>
              {t('createCloud')}
            </a>
          </Link>
          {documentationLink &&
            <a className='btn black' rel='noopener' href={href} target='_blank'>
              {t('menu.about.documentation')}
            </a>}
          {contactButton && <ContactUsModal lang={lang} />}                    </div>
      </div>
    </section>
  );
}
